import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { useSentry } from './services/sentry'

import { definePreset } from '@primeuix/themes';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';

import App from './App2.vue'
import router from './router2'

import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Select from 'primevue/select';
import Textarea from 'primevue/textarea';
import Message from 'primevue/message';
import InputGroup from 'primevue/inputgroup';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Tag from 'primevue/tag'
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import { initYupLocale } from '@/services/yupConfig';

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
useSentry(app, router)
app.use(pinia)
app.use(router)

initYupLocale();

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#e3eaf5',
            100: '#c2d3ea',
            200: '#8fb0d6',
            300: '#5c8dc2',
            400: '#326fb0',
            500: '#1b3764',
            600: '#16305a',
            700: '#11284f',
            800: '#0c2045',
            900: '#081a3b',
            950: '#05132e'
        },
        secondary: {
            50: '#eaf7e2',
            100: '#d2eec2',
            200: '#a5dd85',
            300: '#8cc63f',
            400: '#6cb33f',
            500: '#5ca035',
            600: '#4c8d2b',
            700: '#3c7a21',
            800: '#2c6717',
            900: '#1c540d',
            950: '#0c4103'
        }
    }
});

app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: '.app-dark'
        }
    },
    locale: 'fr'
});

app.component('Button', Button);
app.component('InputText', InputText);
app.component('Password', Password);
app.component('Message', Message);
app.component('InputGroup', InputGroup);
app.component('IconField', IconField);
app.component('InputIcon', InputIcon);
app.component('Select', Select);
app.component('Tag', Tag);
app.component('Textarea', Textarea);

app.use(ToastService);
app.use(ConfirmationService);

app.mount('#app2')
